import { Box, Grid, PropTypes, Typography, withStyles } from '@material-ui/core'
import { grey } from '@material-ui/core/colors'
import { Variant } from '@material-ui/core/styles/createTypography'
import { observer } from 'mobx-react-lite'
import React from 'react'
import QRCode from 'react-qr-code'
import Spacer from 'src/components/Spacer'
import userStore from 'src/stores/user'
import { formatCpfCnpj } from 'src/utils/formatters'
import { LoteProgramacaoSnapshot, ProgramacaoDetail } from '../../types'
import Watermark from '@uiw/react-watermark'

import { BRAND } from '../../../../config/branding'

interface Props {
  programacao: ProgramacaoDetail
  configJudridico?: string
  configEstadias?: string
  configValidade?: string
}
interface HeaderProps {
  programacaoId: number
  centroCusto: {
    telefone: string
    endereco: string
    cnpj: string
    nomeExibicao: string
    inscricaoEstadual: string
  }
}

interface FooterProps {
  programacaoId: string
  centroCusto: string
  status: string
  page: number
  totalPages: number
  configJudridico?: string
  configEstadias?: string
  configValidade?: string
}

interface BodyProps {
  programacao: ProgramacaoDetail
  lote: LoteProgramacaoSnapshot
}

const WhiteTextTypography = withStyles({
  root: {
    color: '#FFFFFF'
  }
})(Typography)

const RedTextTypography = withStyles({
  root: {
    color: 'red'
  }
})(Typography)

const InfoField = ({
  text,
  variant,
  style,
  align
}: {
  text?: string
  variant?: 'inherit' | Variant
  style?: React.CSSProperties
  align?: PropTypes.Alignment
}) => (
  <Typography
    variant={variant}
    align={align ?? 'center'}
    style={{
      backgroundColor: grey[200],
      ...style
    }}
  >
    {text ?? '-'}
  </Typography>
)

const AutorizacaoCarregamentoHeader = ({
  programacaoId,
  centroCusto
}: HeaderProps) => {
  return (
    <Grid
      container
      spacing={1}
      alignItems="center"
      style={{
        borderColor: '#632336',
        border: 'solid .5rem #632336',
        borderLeftWidth: '0rem',
        borderRightWidth: '0rem',
        fontWeight: 'bold'
      }}
    >
      <Grid item xs={6}>
        <img
          alt="logo"
          src={BRAND.svg}
          style={{
            paddingLeft: '20%',
            width: '50%',
            height: 'auto'
          }}
        />
      </Grid>
      <Grid item xs={6}>
        <Grid container spacing={1} justifyContent="center">
          <Grid item xs={12}>
            <WhiteTextTypography
              style={{ fontSize: 10, color: '#000', fontWeight: 'bold' }}
              align="center"
            >
              {centroCusto.nomeExibicao?.toUpperCase() ?? '-'}
            </WhiteTextTypography>
          </Grid>
          <Grid item xs={12}>
            <WhiteTextTypography
              style={{ fontSize: 10, color: '#000', fontWeight: 'bold' }}
              align="center"
            >
              {centroCusto.endereco ?? '-'}
            </WhiteTextTypography>
          </Grid>
          <Grid item xs={12}>
            <WhiteTextTypography
              style={{ fontSize: 10, color: '#000', fontWeight: 'bold' }}
              align="center"
            >
              CNPJ: {centroCusto.cnpj ?? '-'} I.E.:{' '}
              {centroCusto.inscricaoEstadual ?? '-'} TELEFONE:{' '}
              {centroCusto.telefone ?? '-'}
            </WhiteTextTypography>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <Grid container spacing={1}>
          <Grid item xs={6}>
            <WhiteTextTypography
              variant="h6"
              align="center"
              style={{ color: '#000', fontWeight: 'bold' }}
            >
              <Box fontWeight="bold">AUTORIZAÇÃO DE CARREGAMENTO</Box>
            </WhiteTextTypography>
          </Grid>
          <Grid item xs={6}>
            <RedTextTypography
              variant="h6"
              align="center"
              style={{
                backgroundColor: grey[200]
              }}
            >
              {programacaoId}
            </RedTextTypography>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}

const AutorizacaoCarregamentoBody = ({ programacao, lote }: BodyProps) => {
  const BodyItem = ({
    label,
    item
  }: {
    label: string
    item: React.ReactNode
  }) => (
    <Grid
      container
      spacing={1}
      justifyContent="space-evenly"
      alignItems="center"
    >
      <Grid item xs={2}>
        <Typography style={{ fontSize: 10, fontWeight: 'bold' }}>
          {label}
        </Typography>
      </Grid>
      <Grid item xs={8}>
        {item}
      </Grid>
    </Grid>
  )

  const TrocaNotas = () => (
    <React.Fragment>
      {lote.LoteProgramacaoPernaSnapshot.map((perna, index) => {
        if (index === 0) return null

        return (
          <>
            <Grid item xs={12}>
              <BodyItem
                label={`TROCA DE NOTA ${index}`}
                item={
                  <Grid container spacing={1}>
                    <Grid item xs={12}>
                      <InfoField
                        text={perna.localCarregamento || '-'}
                        style={{ fontSize: 10, fontWeight: 'bold' }}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <InfoField
                        text={perna.cidadeOrigem}
                        style={{ fontSize: 10, fontWeight: 'bold' }}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <InfoField
                        text={perna.estadoOrigem}
                        style={{ fontSize: 10, fontWeight: 'bold' }}
                      />
                    </Grid>
                  </Grid>
                }
              />
            </Grid>
          </>
        )
      })}
    </React.Fragment>
  )

  return (
    <>
      <Spacer y={1} />
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <BodyItem
            label="CENTRO DE CUSTO"
            item={
              <InfoField
                text={programacao.CentroCusto?.descricao}
                style={{ fontSize: 10, fontWeight: 'bold' }}
              />
            }
          />
        </Grid>
        <Grid item xs={12}>
          <BodyItem
            label="CLIENTE"
            item={
              <InfoField
                text={lote.clienteNome}
                style={{ fontSize: 10, fontWeight: 'bold' }}
              />
            }
          />
        </Grid>
        <Grid item xs={12}>
          <BodyItem
            label="COLETA"
            item={
              <Grid container spacing={1}>
                <Grid item xs={12}>
                  <InfoField
                    text={lote.localCarregamento || '-'}
                    style={{ fontSize: 10, fontWeight: 'bold' }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <InfoField
                    text={lote.cidadeOrigem}
                    style={{ fontSize: 10, fontWeight: 'bold' }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <InfoField
                    text={lote.estadoOrigem}
                    style={{ fontSize: 10, fontWeight: 'bold' }}
                  />
                </Grid>
              </Grid>
            }
          />
        </Grid>
        <TrocaNotas />
        {lote.LoteProgramacaoDestinoSnapshot.map((destino, index) => (
          <>
            <Grid item xs={12}>
              <BodyItem
                label={
                  lote.LoteProgramacaoDestinoSnapshot.length > 1
                    ? `${index + 1}ª ENTREGA`
                    : 'ENTREGA'
                }
                item={
                  <Grid container spacing={1}>
                    <Grid item xs={12}>
                      <InfoField
                        text={destino.localDescarregamento || '-'}
                        style={{ fontSize: 10, fontWeight: 'bold' }}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <InfoField
                        text={destino.cidadeDestino}
                        style={{ fontSize: 10, fontWeight: 'bold' }}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <InfoField
                        text={destino.estadoDestino}
                        style={{ fontSize: 10, fontWeight: 'bold' }}
                      />
                    </Grid>
                  </Grid>
                }
              />
            </Grid>
          </>
        ))}
        <Grid item xs={12}>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <BodyItem
                label="PRODUTO"
                item={
                  <InfoField
                    text={lote.produtoNome || 'Não Informado'}
                    style={{ fontSize: 10, fontWeight: 'bold' }}
                  />
                }
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <BodyItem
            label="VEÍCULO"
            item={
              <Grid container spacing={1}>
                <Grid item xs={3}>
                  <InfoField
                    text={programacao.placaPrincipal}
                    style={{ fontSize: 10, fontWeight: 'bold' }}
                  />
                </Grid>
                <Grid item xs={3}>
                  <InfoField
                    text={programacao.placa_1}
                    style={{ fontSize: 10, fontWeight: 'bold' }}
                  />
                </Grid>
                <Grid item xs={3}>
                  <InfoField
                    text={programacao.placa_2}
                    style={{ fontSize: 10, fontWeight: 'bold' }}
                  />
                </Grid>
                <Grid item xs={3}>
                  <InfoField
                    text={programacao.placa_3}
                    style={{ fontSize: 10, fontWeight: 'bold' }}
                  />
                </Grid>
              </Grid>
            }
          />
        </Grid>
        <Grid item xs={12}>
          <BodyItem
            label="CAPACIDADE"
            item={
              <InfoField
                text={programacao.capacidadeCargaVeiculo}
                style={{ fontSize: 10, fontWeight: 'bold' }}
              />
            }
          />
        </Grid>
        <Grid item xs={12}>
          <BodyItem
            label="MOTORISTA"
            item={
              <Grid container spacing={1}>
                <Grid item xs={4}>
                  <InfoField
                    text={formatCpfCnpj(programacao.cpfMotorista)}
                    style={{ fontSize: 10, fontWeight: 'bold' }}
                  />
                </Grid>
                <Grid item xs={8}>
                  <InfoField
                    text={programacao.motorista}
                    style={{ fontSize: 10, fontWeight: 'bold' }}
                  />
                </Grid>
              </Grid>
            }
          />
        </Grid>
        <Grid item xs={12}>
          <Grid container spacing={1} alignItems="center">
            <Grid item xs={12}>
              <BodyItem
                label="PREVISÃO DE CARREGAMENTO"
                item={
                  <InfoField
                    text={`${new Date(
                      programacao.dataHoraCarregamento
                    ).toLocaleDateString('pt-br')} ${new Date(
                      programacao.dataHoraCarregamento
                    ).toLocaleTimeString('pt-br')}`}
                    style={{ fontSize: 10, fontWeight: 'bold' }}
                  />
                }
              />
            </Grid>
            <Grid item xs={12}>
              <Grid container spacing={1} alignItems="center">
                <Grid item xs={12}>
                  <BodyItem
                    label="PEDIDO"
                    item={
                      <InfoField
                        text={lote.numeroPedido || '-'}
                        style={{ fontSize: 10, fontWeight: 'bold' }}
                      />
                    }
                  />
                </Grid>
                <Grid item xs={12}>
                  <BodyItem
                    label="OBSERVAÇÕES"
                    item={
                      <InfoField
                        align={
                          programacao.observacoes?.length ?? 1 > 15
                            ? 'justify'
                            : 'center'
                        }
                        text={programacao.observacoes ?? '-'}
                        style={{
                          fontSize: 10,
                          fontWeight: 'bold',
                          paddingLeft: 2,
                          paddingRight: 2
                        }}
                      />
                    }
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Spacer y={1} />
      <hr
        style={{
          height: '2px',
          backgroundColor: 'black',
          border: 'none'
        }}
      />
    </>
  )
}

const AutorizacaoCarregamentoFooter = observer(
  ({
    programacaoId,
    centroCusto,
    status,
    page,
    totalPages,
    configJudridico,
    configEstadias,
    configValidade
  }: FooterProps) => {
    const lineSeparator = '<br />'
    const justifyLength = 200

    const user = userStore.data
    const date = new Date()

    const Assinatura = ({ caption }: { caption: string }) => {
      return (
        <div>
          <hr
            style={{
              color: 'black'
            }}
          />
          <Typography style={{ fontSize: 9, fontWeight: 'bold' }}>
            {caption}
          </Typography>
        </div>
      )
    }

    const textoJuridico =
      configJudridico ||
      'AUTORIZAÇÃO DE CARREGAMENTO VÁLIDA SOMENTE COM A EFETIVA APRESENTAÇÃO DO SUBCONTRATADO NO LOCAL DE EMBARQUE DENTRO DO PRAZO DE VALIDADE PREVISTO ABAIXO.'
    const textoEstadias =
      configEstadias ||
      'O subcontratado declara que todas as regras específicas de embarque, agendamento combinado, regras em caso de estadia (tarifa, datas de agendamento, tempos de tolerâncias, etc), regras de PGR, rastreamento/monitoramento  e seguros, incluindo as rotas por ele escolhidas, com ou sem pedágio e respectiva forma de pagamento quando houver pedágio na rota escolhida pelo subcontratado, e demais termos da subcontratação foram devidamente explicados e acordados previamente a emissão da presente autorização de carregamento; O SUBCONTRATADO e seus prepostos declaram expressamente, na condição de motorista subcontratado e/ou de preposto de ETC ou TAC subcontratado(a), conforme qualificações melhores descritas no DACTE respectivo a esta ordem de carregamento, estar ciente, e concordar sem ressalvas, que, em razão de vantagens no valor da tarifa do frete contratado e acordado entre as partes, no valor do frete contratado/acordado, está contemplada a indenização por um tempo de espera até a data do agendamento constante do DACTE, documento de agendamento, agendamento no portal do destinatário ou APP equivalente. Declara, ainda, que concordou com todas as especificidades do transporte subcontratado, as quais serão reproduzidas no campo de observações do DACTe e demais documentos de transporte (condições gerais do contrato de transporte), assinando o presente termo para formalizar sua expressa concordância, sem ressalvas, para todas as regras do frete subcontratado. Declara por fim que, independentemente de assinatura, a mera aceitação da ordem de carregamento com sua apresentação para carregamento, importa na concordância e aceite das condições e obrigações a serem reproduzidas no campo de observações do DACTE e nas condições gerais do contrato de transporte. <br /> Eventuais estadias, se devidas, serão pagas conforme ajuste prévio, que será anotado no campo observações do DACTE a ser emitido. <br /> O subcontratado declara expressa ciência e concordância com os descontos de ad valorem, taxa administrativa (quando aplicável à operação) e seguros de cargas previstos em Lei. <br /> Fica também previamente acordado que qualquer reclamação relativa a pagamento de frete, estadias e demais reivindicações estarão sujeitas ao prazo decadencial de 30 dias.'
    const validadeAutorizacao = configValidade || '48'

    return (
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <Typography
            style={{ fontSize: 9, fontWeight: 'bold' }}
            align="center"
          >
            {textoJuridico.split(lineSeparator).map((text, index) => (
              <Box key={index} fontWeight="bold">
                {text}
              </Box>
            ))}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography
            style={{ fontSize: 7, fontWeight: 'bold' }}
            align={textoEstadias.length > justifyLength ? 'justify' : 'center'}
          >
            {textoEstadias.split(lineSeparator).map((text, index) => (
              <Box key={index} fontWeight="bold">
                {text}
              </Box>
            ))}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <RedTextTypography
            style={{ fontSize: 12, fontWeight: 'bold' }}
            align="center"
          >
            <Box fontWeight="bold">VALIDADE: {validadeAutorizacao} HORAS</Box>
          </RedTextTypography>
        </Grid>
        <Grid container item xs={10} justifyContent="flex-start">
          <Typography noWrap style={{ fontSize: 7, fontWeight: 'bold' }}>
            De acordo do subcontratado:
          </Typography>
        </Grid>
        <Spacer y={6} />
        <Grid item xs={12}>
          <Grid container spacing={1}>
            <Grid item xs={6}>
              <Assinatura caption="ASSINATURA PREPOSTO/MOTORISTA" />
            </Grid>
            <Grid item xs={6}>
              <Assinatura caption="ASSINATURA EMBARCADOR" />
              <Typography style={{ fontSize: 9, fontWeight: 'bold' }}>
                {`${BRAND.name}`} - {centroCusto}
              </Typography>
            </Grid>
          </Grid>

          <Grid container item justifyContent="space-between">
            <Grid>
              <QRCode value={`${window.location.origin}/cgct`} size={110} />
            </Grid>

            <Grid>
              <QRCode
                value={`${window.location.origin}/autorizacao-carregamento-validacao/${programacaoId}?status=${status}`}
                size={110}
              />
            </Grid>
          </Grid>
        </Grid>
        <Spacer y={4} />
        <Grid item xs={12}>
          <Grid container justifyContent="space-around">
            <Grid container item xs={12} justifyContent="space-between">
              <Typography
                style={{
                  fontSize: 9,
                  fontWeight: 'bold',
                  alignContent: 'flex-end'
                }}
                align="center"
              >
                Acesso às Condições Gerais do Contrato de Prestação de Serviço
                de Transporte
              </Typography>
              <Typography
                style={{
                  fontSize: 9,
                  fontWeight: 'bold',
                  alignContent: 'flex-end'
                }}
                align="center"
              >
                Autentique a Autorização de Carregamento aqui
              </Typography>
            </Grid>
            <Grid container item xs={10} justifyContent="flex-start">
              <Typography noWrap style={{ fontSize: 7, fontWeight: 'bold' }}>
                IMPRESSÃO: {user?.username} {date.toLocaleDateString('pt-br')}{' '}
                {date.toLocaleTimeString('pt-br')}
              </Typography>
            </Grid>
            <Grid container item xs={2} justifyContent="flex-end">
              <Typography
                noWrap
                style={{
                  fontSize: 9,
                  fontWeight: 'bold',
                  alignContent: 'flex-end'
                }}
              >
                Autorização {page} de {totalPages}
              </Typography>
            </Grid>
          </Grid>
          <hr
            style={{
              height: '2px',
              backgroundColor: 'black',
              border: 'none'
            }}
          />
        </Grid>
      </Grid>
    )
  }
)

const AutorizacaoCarregamentoPrint = ({
  programacao,
  configJudridico,
  configEstadias,
  configValidade
}: Props) => {
  const totalLotes = programacao.LoteProgramacaoSnapshot.length
  return (
    <React.Fragment>
      {programacao.LoteProgramacaoSnapshot.map((lote, index) => (
        <Watermark
          image={BRAND.watermark}
          rotate={0}
          width={704}
          height={1024}
          offsetTop={-2}
          offsetLeft={-2}
        >
          <div style={{ margin: 15 }}>
            <div className="page-break" />
            {programacao.status === 'CANCELADO' && (
              <div
                style={{
                  display: 'grid',
                  justifyContent: 'center',
                  alignContent: 'center',
                  transform: 'rotate(45deg)',
                  position: 'fixed',
                  top: 0,
                  bottom: 0,
                  left: 0,
                  right: 0,
                  zIndex: 1
                }}
              >
                <Typography
                  style={{
                    fontSize: 120,
                    opacity: 0.4,
                    color: '#632336',
                    fontWeight: 'bold'
                  }}
                >
                  CANCELADO
                </Typography>
              </div>
            )}

            <Grid container spacing={1}>
              <Grid item xs={12}>
                <AutorizacaoCarregamentoHeader
                  programacaoId={programacao.codigo}
                  centroCusto={{
                    cnpj: lote.centroCustoCnpj,
                    nomeExibicao: lote.centroCustoNome,
                    endereco: lote.centroCustoEndereco,
                    inscricaoEstadual: lote.centroCustoInscricaoEstadual,
                    telefone: lote.centroCustoTelefone
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <AutorizacaoCarregamentoBody
                  programacao={programacao}
                  lote={lote}
                />
              </Grid>
              <Grid item xs={12}>
                <AutorizacaoCarregamentoFooter
                  programacaoId={programacao.id}
                  centroCusto={programacao.CentroCusto!.descricao}
                  status={programacao.status}
                  page={index + 1}
                  totalPages={totalLotes}
                  configJudridico={configJudridico}
                  configEstadias={configEstadias}
                  configValidade={configValidade}
                />
              </Grid>
            </Grid>
          </div>
        </Watermark>
      ))}
    </React.Fragment>
  )
}

export default AutorizacaoCarregamentoPrint
